var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('p', _vm._b({
    staticClass: "cosmic_page_description",
    class: {
      [_vm.color]: _vm.color && !_vm.isValidColorValue,
      no_margin_left: _vm.removeMarginLeft,
      no_margin_bottom: _vm.removeMarginBottom
    },
    style: {
      borderLeftColor: _vm.isValidColorValue ? _vm.color : undefined
    }
  }, 'p', {
    ..._vm.$listeners
  }, false), [_vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };